import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../../assets/images/Logo.png';
import group208 from '../../assets/images/Group 208.png';
import rectangle15 from '../../assets/images/Rectangle 15.png';
import asset51 from '../../assets/images/Asset 5 1.png';
import { FaArrowRight, FaLocationDot } from "react-icons/fa6";
import rich from '../../assets/images/lgD.png';
import './sucess.css';

const Success = () => {

  const location = useLocation();
  const hospital_admin_id = location.state; // Data sent from SignUp

  // const newformData = location.state; // Data sent from SignUp
  // const otherResponseDtatas = location.other; // Data sent from SignUp
  // console.log(hospital_admin_id);

  const navigate = useNavigate();

  // Fonction qui sera appelée lors du clic sur le bouton
  const handleContinue = (e) => {
    e.preventDefault(); // Prévenir la soumission du formulaire (bien que ce ne soit pas strictement nécessaire ici)
    navigate('/subscription', { state: hospital_admin_id }); // Redirige l'utilisateur vers la page Subscription
  };

  return (

    <div className="sucess-container">

      <div className='admin-signup-section ps-md-5 ps-1 mt-lg-5 mt-1'>
        <div className="sucess-logo">MED<span className='richy'>TINZ</span></div>
        <h2 className="sucess-title">Create an account</h2>
        <div className="sucess-login-link">
          Already have an account?
          <a href="/clientlogin" className="sucess-login-link-text">Log in</a>
        </div>
        <div class="success-container">
          <img src={asset51} alt="Success indicator" className="success-image" />
          <div class="badge-wrapper">
            <h4 class="success-badge">SUCCESS</h4>
          </div>
        </div>
        {/* Submit Button */}
        <button onClick={handleContinue} className="btn btn-vtn py-3" style={{ background: '#28A745', width: '90%', color: 'white', fontWeight: '600', fontSize: '20px' }}>Continue  <span className="admin-submit-arrow ms-2">→</span></button>
      </div>

      <div className="sucess-preview-section">
        <div className="" >
          <img src={rich} alt="rich" className="sucess-preview-image" />
          <div className="into mt-4">
            <div className="admin-preview-text">
              Manage your hospital with <span className="admin-highlight">ease</span> now..
            </div>
            <img src={rectangle15} alt="Group 208" className="sucess-morije" />
          </div>
        </div>
      </div>
      <div className="sucess-footer">
        © 2024 | Développé par ITTIQ
      </div>


    </div>
  );
};

export default Success;
